<p-dialog [(visible)]="displayAddEditRoute" [modal]="true" [closable]="false" [style]="{width: '60vw'}">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 50%;">
            <h5 class="p-mb-0">{{ dialogHeader }}</h5>
        </div>
    </ng-template>
    <ng-container>
        <form [formGroup]="routeForm" novalidate>
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-12 p-md-12">
                        <label>Route Name <span style="color: red;">*</span></label>
                        <input formControlName="routeName" pInputText>
                        <div *ngIf="detailsFormErrors?.routeName" class="p-invalid">
                            <small>{{ detailsFormErrors?.routeName}}</small>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <label>Module <span style="color: red;">*</span></label>
                        <p-dropdown appendTo="body" [options]="routeModules" formControlName="objectTypeId" [disabled]="routeViewOnly || routesLists?.length"
                           (onChange)="onChangeModule()" optionLabel="name" optionValue="id" required placeholder="Select Module">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.objectTypeId" class="p-invalid">
                            <small>{{ detailsFormErrors?.objectTypeId}}</small>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <label>Assigned To <span style="color: red;">*</span></label>
                        <p-dropdown appendTo="body" [options]="userList" formControlName="userId" [disabled]="routeViewOnly || routesLists?.length"
                        (onChange)="onChangeModule()" optionLabel="name" optionValue="id" [filter]="true" required placeholder="Select User">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.userId" class="p-invalid">
                            <small>{{ detailsFormErrors?.userId}}</small>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6">
                        <label>Start Location<span style="color: red;">*</span></label>
                        <div>
                            <lion-gm-place-autocomplete [formattedAddress]="startAddressInput"
                                (onAddressChange)="addressChange($event)" [disabled]="routeViewOnly">
                            </lion-gm-place-autocomplete>
                        </div>

                    </div>
                    <div class="p-col-12 p-md-6">
                        <label>End Location</label>
                        <div>
                            <lion-gm-place-autocomplete [formattedAddress]="endAddressInput"
                                (onAddressChange)="endLocationChange($event)" [disabled]="routeViewOnly">
                            </lion-gm-place-autocomplete>
                        </div>

                    </div>
                    <div class="p-col-12 p-md-6"></div>
                    <div class="p-col-12 p-md-6">
                        <p-checkbox formControlName="isEndLocationSame" binary="true" inputId="binary"
                            (onChange)="onSameasStartLocation($event)">
                        </p-checkbox> &nbsp;Same as Start Location
                    </div>
                </div>
            </div>
        </form>
        <div class="header p-d-flex p-jc-between" style="position: relative; height: 43px;">
            <h5 class="p-mt-2">Route Store Selection (Max 25) <span style="color: red;">*</span></h5>
            <div style="width: 31%">
                <p-selectButton [options]="viewModeNew" [ngModelOptions]="{standalone: true}" [disabled]="!routesLists?.length"
                    (onChange)="changeViewMode($event)" [(ngModel)]="selectedViewModeNew">
                </p-selectButton>
            </div>
            <div class="btn-group">
                <p-button *ngIf="routesLists?.length > 0 && !routeViewOnly" label="Clear" class="p-mr-2" (click)="resetData()"></p-button>
                <p-button [disabled]="routeViewOnly || !routeForm.getRawValue().userId" icon="pi pi-plus" (click)="showRouteTB()"></p-button>
            </div>
        </div>
        <div class="card" style="margin-bottom: 100px">
            <p-table *ngIf="selectedViewModeNew == 'classic'" [columns]="accountColLists" [value]="routesLists"
                [paginator]="true" [scrollable]="true" [totalRecords]="(routesLists?.length||0)" [(first)]="first"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="tableShowMore" [rows]="15" styleClass="p-datatable-gridlines"
                [resizableColumns]="true">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col.enabled && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)" [class.action-tag]="col.columnName =='tags'" pResizableColumn
                                style="border-right: 1px solid var(--primary-color);">
                                {{col.name}}
                            </th>
                        </ng-container>
                        <th>Channel</th>
                        <th>Territory</th>
                        <th>Route Assigned</th>
                        <th *ngIf="!routeViewOnly" style="width: 4rem;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.enabled && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)" [class.action-tag]="col.columnName =='tags'">
                                <ng-container>
                                    <ng-container *ngIf="col.columnName =='businessName'">
                                        <app-color-box [color]="rowData.classificationColor"></app-color-box>
                                    </ng-container>
                                    <ng-container *ngIf="col.columnName =='tags'">
                                        <ng-container *ngFor="let s of rowData?.tags; let i = index">
                                            <p-tag styleClass="p-ml-1" [value]="s?.name"
                                                [style]="{'background-color': s.color}"></p-tag>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="['twitter','website','other','facebook','linkedin','instagram'].indexOf(col.columnName) >= 0; else elseData">
                                        <a href="{{rowData[col.columnName]}}" target="_blank">{{rowData[col.columnName]
                                            | shorten }}</a>
                                    </ng-container>
                                    <ng-template #elseData>
                                        <ng-container *ngIf="col.columnName != 'tags'">
                                            <ng-container [ngSwitch]="col?.fieldDataType">
                                                <ng-container *ngSwitchCase="'DateTime'">
                                                    {{ rowData[col.columnName] | date:'MM/dd/yyyy' }}
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    <ng-container *ngIf="col.columnName =='businessName' && rowData?.sequenceNumber && mergeAccountSequenceNumber">
                                                        {{ rowData?.sequenceNumber }} -
                                                    </ng-container>
                                                    {{rowData[col.columnName]}}
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                        <span *ngIf="col.columnName === 'currentStage' && rowData?.isConvertedToAccount">*</span>
                                    </ng-template>
                                </ng-container>
                            </td>
                        </ng-container>
                        <td>{{rowData.channelName}}</td>
                        <td>{{rowData?.TerritoryName||rowData?.territoryName}}</td>
                        <td>{{rowData.routeAssigned}}</td>
                        <td style="width: 4rem">
                            <span class="p-p-2 p-mr-2" style="cursor: pointer" pTooltip="Remove" tooltipPosition="top" (click)="removeStore(rowData)">
                                <i class="pi pi-trash"></i>
                            </span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="30">No Routes Selected.</td>
                    </tr>
                </ng-template>
            </p-table>
            <div id="gmap1" name="maps" style="width: 0%; height: 0;"></div>
            <div [class.hidden]="selectedViewModeNew != 'map'">
                <div id="gmap" name="maps" style="width: 100%; height: 320px;"></div>
            </div>
        </div>
    </ng-container>
    <p-footer>
        <button type="button" pButton (click)="closeRouteDialog()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="crudType!='view'" type="button" pButton class="p-button-label" label="Save"   [disabled]="startAddressInput =='' ||routesLists?.length === 0" (click)="saveRoute()"
            ></button>
    </p-footer>
</p-dialog>

<!-- table for show all Store for Selection when click on plus icon -->

<p-dialog [(visible)]="displayRouteTB" [modal]="true" [responsive]="true" [style]="{width: '85vw'}" [closable]="false" (onHide)="onDialogHide()">
    <div class="card" style="margin-bottom: 100px;">
        <p-table #accountsTable [columns]="savedAccountListCols" [lazy]="true" [loading]="loading" [(first)]="first"
            (onLazyLoad)="paginationGetRouteStoreLocationListing($event)" [value]="businessList" [paginator]="true"
            [rows]="pageSize" [totalRecords]="lsttotalRecords" selectionMode="multiple" [(selection)]="selectedBusiness"
            [showCurrentPageReport]="true" [scrollable]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="tableShowMore" dataKey="objectRefRecordId" (onRowSelect)="onRowSelectRoute($event)"
            (onRowUnselect)="onRowUnSelectRoute($event)" responsiveLayout="scroll" styleClass="p-datatable-gridlines"
            [resizableColumns]="true">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-jc-between">
                    <div class="p-d-flex p-ai-center">
                        <p-dropdown appendTo="body" [options]="channelsN" [(ngModel)]="selectedChannelN"
                            (onChange)="onChangeChannel($event)" [pTooltip]="'Select Channel'"
                            optionLabel="name" placeholder="Select Channel" class="p-mr-2">
                        </p-dropdown>
                        <liono-treeSelect [options]="territoryNamesList"
                            [(ngModel)]="selectedTerritory"
                            (onNodeSelect)="changeTerritory($event)" appendTo="body"
                            placeholder="Select Parent Territory" [filter]="true"
                            [metaKeySelection]="false" [pTooltip]="'Select Territory'"
                            [filterInputAutoFocus]="true">
                        </liono-treeSelect>
                        <span class="p-input-icon-left p-ml-2">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" [(ngModel)]="globalFilterInputBS"
                                (input)="onGlobalRouteStoreSearch()" [ngModelOptions]="{standalone: true}"
                                placeholder="Search..." />
                        </span>
                        <div class="p-ml-2">{{ selectedBusiness?.length }} Selected (Max 25)</div>
                    </div>
                    <div class="p-d-flex p-ai-center">
                        <div>
                            <app-filters [listCols]="newFillterListCols" [selectedParentModule]="selectedFilterModule"
                                (applyFiltersColumns)="applyFilters($event)"></app-filters>
                        </div>
                        <p-checkbox [disabled]="isView" [(ngModel)]="selectedStore" [binary]="true"
                            class="add-margin-right p-mr-2" label="Show only assigned"
                            (onChange)="onAssignedCheckboxChange()"></p-checkbox>
                        <p-button label="Setting" (click)="showSetting()"></p-button>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <ng-container *ngFor="let col of columns">
                        <th *ngIf="col.enabled && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)" [pSortableColumn]="col.columnName" pResizableColumn
                            [pSortableColumnDisabled]="['tags'].includes(col.columnName)"
                            style="border-right: 1px solid var(--primary-color);"
                            [class.action-tag]="col.columnName =='tags'">
                            {{col.name}}
                            <p-sortIcon style="margin-right: 3px;" *ngIf="!['tags'].includes(col.columnName)"
                                [field]="col.columnName" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                    </ng-container>
                    <th> Route Assigned</th>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox (click)="CheckAllRoute(e.checked)" #e></p-tableHeaderCheckbox>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                    <ng-container *ngFor="let col of columns">
                        <td *ngIf="col.enabled && !(col.columnName == 'sequenceNumber' && mergeAccountSequenceNumber)" style="text-align: left;word-break: break-all;"
                            [class.action-tag]="col.columnName =='tags'">
                            <ng-container>
                                <ng-container *ngIf="col.columnName =='businessName' && rowData.classificationColor">
                                    <app-color-box class="colorBoxStyle"
                                        [color]="rowData.classificationColor"></app-color-box>
                                </ng-container>
                                <ng-container *ngIf="col.columnName =='tags'">
                                    <ng-container *ngFor="let s of rowData?.tags; let i = index">
                                        <p-tag styleClass="p-ml-1" [value]="s?.name"
                                            [style]="{'background-color': s.color}"></p-tag>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="['twitter','website', 'facebook','linkedin','instagram',
                                                      'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                                      'contactsociallinkedin','contactsocialinstagram'].indexOf(col.columnName) >= 0;
                                                      else elseData">
                                    <a href="{{rowData[col.columnName] | url}}" target="_blank">{{
                                        rowData[col.columnName] | shorten
                                        }}</a>
                                </ng-container>
                                <ng-template #elseData>
                                    <ng-container *ngIf="col.columnName != 'tags'">
                                        <ng-container [ngSwitch]="col?.fieldDataType">
                                            <ng-container *ngSwitchCase="'DateTime'">
                                                {{ rowData[col.columnName] | date:'MM/dd/yyyy' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                <ng-container *ngIf="col.columnName =='businessName' && rowData?.sequenceNumber && mergeAccountSequenceNumber">
                                                    {{ rowData?.sequenceNumber }} -
                                                </ng-container>
                                                {{rowData[col.columnName]}}
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <span *ngIf="col.columnName === 'currentStage' && rowData?.isConvertedToAccount">*</span>
                                </ng-template>
                            </ng-container>
                        </td>
                    </ng-container>
                    <td>{{rowData.routeAssigned}}</td>
                    <td>
                        <p-tableCheckbox [value]="rowData" [pSelectableRow]="rowData" #e></p-tableCheckbox>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="30">No Routes Available.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="resetRouteTB()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="saveRouteTB();" label="Save"></button>
    </p-footer>
</p-dialog>

<div *ngIf="displayRouteTB ">
    <app-column-settings-modal-for-rules
      [displayColumnSettings]="displayColumnSettings"
      [moduleName]="selectedTerritory?.territoryType" [settingsObj]="routeColumnSetttings" [selectedView]="'list'"
      [mergeAccountSequenceNumber]="mergeAccountSequenceNumber"
      [channelId]="selectedChannelN?.id" (savedColumnSettings)="savedColumnSettings($event)"
      (cancelColumnSettings)="cancelColumnSettings()">
    </app-column-settings-modal-for-rules>
</div>
